import React, { useEffect } from 'react';
import { useState } from 'react';

import t from '../Translation/Translation';
import { IonButtons, IonContent, IonHeader, IonPage, IonTitle, IonToolbar, IonMenuToggle, IonGrid, IonRow, IonCol, IonCard, IonCardContent, IonCardHeader, IonCardSubtitle, IonCardTitle, IonButton, IonIcon, IonFooter } from '@ionic/react';
import { useIonViewDidEnter } from '@ionic/react';
import { Row, Col } from 'react-bootstrap';
import { arrowBack } from 'ionicons/icons';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { Loader, CustomTable } from 'citric_components';
import Menubar from '../Dashboard/Menubar';
import { App } from '@capacitor/app';
import SummaryMin from '../Summary/SummaryMin';

import { Avatar } from 'citric_components';

import CardImg from '../../images/card.png';
import { useNavigate } from 'react-router';

import conf from '../../config.json';
import { logD } from '../Util/Util';
import i18next from 'i18next';
import Header from '../Dashboard/Header';

export default function Customers(props) {
    logD("Customers", props);
    const [customers, setCustomers] = useState(props.customers);
    //const customers = props.customers;
    console.log(props);
    console.log(customers);

    const navigate = useNavigate();

    function back() {
        //props.setProject(null);
        setTimeout(function(){
            navigate(-1);
        }, 1);
        //navigate.go(-1);
    }

    useIonViewDidEnter(async () => {
        App.addListener('backButton', ({canGoBack}) => {
            
            if(!canGoBack){
                App.exitApp();
            } else {
                back();
            }
        });
    });

    

    function openURLInNewTab(url) {
        window.open(url, '_blank');
    }

    const columns = [
        {
            Header: t('id'),
            accessor: 'idCustomer',
        },
        {
            Header: t('actions'),
            id: 'actions',
            accessor: (d) => {
                return <>
                   <IonButton color="primary" onClick={async (e) => {
                            e.preventDefault();
                            setCustomers(null);
                            props.getProjectsFromCustomer(d);
                            /*setTimeout(function(){
                                navigate('../projects');
                            }, 100);*/
                        }
                    }>
                        {t('load')}
                    </IonButton>
                </>
            }
        },
        {
            Header: t('code'),
            accessor: 'code',
        },
        {
            Header: t('name'),
            accessor: 'name',
        },
        {
            Header: t('desc'),
            accessor: 'desc',
        }
    ];

    var hiddenColumns = [];
    
    return (
        <>
            <Menubar lang={props.lang} setLang={props.setLang} token={props.token} setToken={props.setToken} contentId="customers"/>
            <IonPage id="customers">
                <IonHeader>
                    <Header lang={props.lang} setLang={props.setLang} token={props.token} setToken={props.setToken}/>
                    {/*<IonToolbar>
                        
                        <IonButtons slot="start">
                            <IonMenuToggle className="ion-padding-start">
                                <Avatar name={props.token.name.charAt(0).toUpperCase()}/>
                            </IonMenuToggle>
                        </IonButtons>
                        <IonTitle>{t('customers')}</IonTitle>
                    </IonToolbar>*/}
                </IonHeader>
                <IonContent className="ion-padding">
                    {customers == null && <Loader />}
                    {
                        customers != null &&
                        <CustomTable keyField='idCustomer' desc={false} data={customers} columns={columns} isFilter={true} isPagination={true} isSelection={false} hasActions={false} hiddenColumns={hiddenColumns} isExport={true} pagesNumber={4}/>
                    }
                </IonContent>
                <IonFooter>
                    <IonToolbar>
                        <IonTitle className="text-center">{t('logged_in_as')} <span className='color-orange'><b>{props.token.name}</b></span></IonTitle>
                    </IonToolbar>
                </IonFooter>
            </IonPage>
        </>
    );
}